class CartPage extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.querySelector('[data-cart-line-item-status]') || document.querySelector('[data-cart-drawer-line-item-status]');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = window.debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-items',
        section: 'cart-items',
        selector: '[data-cart-items]'
      },
      {
        id: 'cart-subtotal',
        section: 'cart-subtotal',
        selector: '[data-cart-subtotal]'
      },
      {
        id: 'cart-count',
        section: 'cart-count',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${window.routes.cart_change_url}`, {...window.fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.classList.toggle('is-empty', parsedState.item_count === 0);

        const cartDrawerWrapper = document.querySelector('cart-drawer');

        if (cartDrawerWrapper) {
          cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        }

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        const cartCountIcon = document.querySelector('[data-cart-count-icon]');
        const cartCountValue = document.querySelector('[data-cart-count-value]');

        if (cartCountIcon && cartCountValue) {
          cartCountValue.innerHTML = cartCountValue.innerHTML.replace('(', '').replace(')', '');
        }

        const cartCountBadge = document.querySelector('[data-cart-count-badge]');

        if (cartCountBadge) {
          if (parsedState.item_count === 0) {
            cartCountBadge.classList.remove('active');
          } else {
            cartCountBadge.classList.add('active');
          }
        }

        this.updateLiveRegions(line, parsedState.item_count);

        const lineItem = document.querySelector(`[data-cart-item="${line}"]`);

        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? window.trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          window.trapFocus(cartDrawerWrapper.querySelector('[data-cart-drawer-inner-empty]'), cartDrawerWrapper.querySelector('a'));

          const cartCountBadge = document.querySelector('[data-cart-count-badge]');

          if (cartCountBadge) {
            cartCountBadge.classList.remove('active');
          }
        } else if (document.querySelector('[data-cart-item]') && cartDrawerWrapper) {
          window.trapFocus(cartDrawerWrapper, document.querySelector('[data-cart-item]'));
        }

        this.disableLoading();
      }).catch(() => {
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemErrors = document.querySelectorAll(`[data-cart-item-error="${line}"]`);
      const quantityInput = document.querySelectorAll(`[data-cart-item-quantity-input="${line}"]`)[0];

      lineItemErrors.forEach((lineItemError) => {
        lineItemError.innerHTML = window.cartStrings.quantityError.replace('[quantity]', quantityInput.value);
      });
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.querySelector('[data-cart-live-region-text]') || document.querySelector('[data-cart-drawer-live-region-text]');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading() {
    const cartContent = document.querySelector('[data-cart-content]') || document.querySelector('[data-cart-drawer-content]');
    cartContent.classList.add('cart__content--disabled');
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const cartContent = document.querySelector('[data-cart-content]') || document.querySelector('[data-cart-drawer-content]');
    cartContent.classList.remove('cart__content--disabled');
  }
}

customElements.define('cart-page', CartPage);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-page') || this.closest('cart-drawer-items');

      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', window.debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${window.routes.cart_update_url}`, {...window.fetchConfig(), ...{ body }});
    }, 300));
  }
}

customElements.define('cart-note', CartNote);